import styled from "styled-components";

export const CardVerse = styled.div`
  position: relative;
  width: 88%;
  padding: 14px 12px;
  margin: 6px 0;
  border-radius: 16px;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  color: var(--text);
  text-align: justify;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  /* fio de luz no topo */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 12%;
    right: 12%;
    height: 2px;
    border-radius: 2px;
    background: var(--gradient-cyan);
    opacity: 0.85;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
    border-color: var(--border-strong);
  }
`;
